import DateFnsUtils from "@date-io/date-fns"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import { he } from "date-fns/locale"

import { GlobalContextProvider } from "./GlobalContext"

export const ContextProviders = ({ children }) => {
  return (
    <>
      <GlobalContextProvider>
        <MuiPickersUtilsProvider locale={he} utils={DateFnsUtils}>
          {children}
        </MuiPickersUtilsProvider>
      </GlobalContextProvider>
    </>
  )
}
